export const PAYMENT_COMPARISON_TOGGLE_CHART_DATA_TABLE = 'PAYMENT_COMPARISON_TOGGLE_CHART_DATA_TABLE'
